<template>
  <div>
    
    <h2 class="h1-responsive font-weight-bold my-5">{{currentCategory ? currentCategory.title : '최신상품'}}</h2>

    <div class="container">
      <div class="row">
        <template v-for="product in products">
          <Product :key="product.id" :product="product"></Product>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import Product from '@/components/product/Product';

export default {
  name: 'ProductListView',
  components: {
    Product,
  },
  props: {
    categoryId: Number,
  },
  watch: {
    categoryId: function() {
      this.updateProducts();
    },
  },
  computed: {
    products() {
      return this.$store.state.products.currentCatgProducts;
    },
    currentCategory() {
      return this.$store.getters.getCategoryById(this.categoryId);
    },
  },
  created() {
    this.updateProducts();
  },
  methods: {
    updateProducts() {
      this.$store.dispatch('requestProductsByCategory', this.categoryId);
    },
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/ProductListView.vue